import { WorkflowStagesService } from '@/modules/global-settings/onboarder/services/workflow-stages.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the WorkflowStagesService class
const workflowStagesService = new WorkflowStagesService();
// Define the state of the WorkflowStages module
export const state = {
  workflowStages: []
};
// Define the mutations of the WorkflowStages module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the WorkflowStages module
export const actions = {
  /**
   * Get workflow stages
   * @param {Object} object - Vuex context
   * @returns {Array} Array of workflow stages
   *
   */
  getWorkflowStages: async ({ commit }) => {
    try {
      const { data } = await workflowStagesService.getWorkflowStages();
      commit('SET_WORKFLOW_STAGES', data);
      return data;
    } catch (error) {
      Logger.error('getting workflow stages', error);
      throw error;
    }
  },
  /**
   * Update workflow stage
   * @param {Object} object - Vuex context
   * @param {Object} payload - Workflow stage object
   * @returns {void}
   * @private This will re-fetch the workflow stages after updating
   */
  updateWorkflowStage: async ({ dispatch }, payload) => {
    try {
      await workflowStagesService.updateWorkflowStage(payload);
      dispatch('getWorkflowStages');
    } catch (error) {
      Logger.error('updating workflow stages', error);
      throw error;
    }
  }
};
// Define the getters of the WorkflowStages module
export const getters = {
  ...make.getters(state),
  activeWorkflowStages(state) {
    return state.workflowStages.filter((w) => w.active == true);
  }
};
